<template>
    <td-dialog :title="title" :before-close="roleDialogClose" :visible.sync="dialogRoleVisible" width="730px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formRoleInfo" ref="formRoleInfo" :label-width="formLabelWidth" :rules="rules">
            <el-row>
                <el-col :span="13">
                    <el-form-item :label="$t('common.ROLENAME')" prop="roleName">
                        <td-input v-model="formRoleInfo.roleName" :disabled="isOrgType" :maxlength="10"></td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('common.ROLE_TYPE')" prop="roleType">
                        <td-select @change="onChangeRoleType" v-model="formRoleInfo.roleType" :disabled="!isAddData" :placeholder="$t('common.PLEASE_SELECT')" :options="this.roleTypeList" keys="orgType" text="orgName"> </td-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="13">
                    <el-form-item :label="$t('common.VALIDITY_START')" prop="startTime">
                        <td-date-time
                            :editable="false"
                            v-model="formRoleInfo.startTime"
                            type="date"
                            :pickerOptions="pickerBeginDateBefore"
                            :placeholder="$t('common.START_TIME')"
                            :clearable="false"
                        ></td-date-time>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('common.UNTIL')" prop="endTime">
                        <td-date-time
                            :editable="false"
                            v-model="formRoleInfo.endTime"
                            type="date"
                            :pickerOptions="pickerBeginDateAfter"
                            :placeholder="$t('common.END_TIME')"
                            :clearable="false"
                        ></td-date-time>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="isDoorType">
                <el-col :span="13">
                    <el-form-item :label="$t('role.TIME_SCHEDULE')" prop="timeScheduleId">
                        <td-select v-model="formRoleInfo.timeScheduleId" :placeholder="$t('common.PLEASE_SELECT')" :options="this.timeScheduleList" keys="sTimeNoUUID" text="sTimeNoName"> </td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item prop="isHolidayInvalid">
                        <td-checkbox v-model="formRoleInfo.isHolidayInvalid" :trueLabel='1' :falseLabel='0'>{{ $t('role.HOLIDAY_INVALID') }}</td-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item prop="isPasswordNeeded">
                        <td-checkbox v-model="formRoleInfo.isPasswordNeeded" :trueLabel='1' :falseLabel='0'>{{ $t('role.PASSWORD_NEEDED') }}</td-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item prop="isAntiSneak">
                        <td-checkbox v-model="formRoleInfo.isAntiSneak" :trueLabel='1' :falseLabel='0'>{{ $t('role.ANTI_SNEAK') }}</td-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="22">
                    <el-form-item label-width="93px" :label="$t('common.ROLEDESCRIPTION')" prop="description">
                        <td-input type="textarea" v-model="formRoleInfo.description" :maxlength="100" width="100%"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-collapse accordion>
                <el-collapse-item v-show="isOrgType || normalRole" :title="$t('common.MENU_AUTH')">
                    <td-tree
                        height="725px"
                        :invertBoxShow="true"
                        :lazyloading="false"
                        :draggable="false"
                        :showBox="true"
                        :treeList="this.menuList"
                        :defaultProps="defaultProps"
                        nodeKey="menuId"
                        ref="menuTree"
                    >
                    </td-tree>
                </el-collapse-item>
                <el-collapse-item v-show="isOrgType || normalRole"  :title="$t('common.DEPT_AUTH')" v-if="this.orgInitFlg">
                    <td-tree
                        :lazyloading="lazyloading"
                        :height="200"
                        :draggable="false"
                        :isDbClick="false"
                        :isClick="false"
                        :imgloading="true"
                        :typeContent="typeContent"
                        :defaultProps="defaultDeptProps"
                        ref="deptTree"
                        :checkNodes="checkedDept"
                        :calInternal="true"
                        :showBox="true"
                        :invertBoxShow="true"
                        :sCodes="sCodes"
                        :isDistributed="true"
                        :interfaceName="orgTreeUrl"
                        :params="params"
                        :isPaging="true"
                        @queryUrlResponse="queryUrlResponse"
                        node-key="id"
                    >
                    </td-tree>
                </el-collapse-item>
                <el-collapse-item v-show="isDoorType" :title="$t('role.DOOR_AUTH')">
                    <td-tree
                        ref="doorTree"
                        checkStrictly="true"
                        :defaultProps="defaultDeptProps"
                        :lazyloading="true"
                        :isFilter="true"
                        :filter="filter"
                        node-key="id"
                        :height="280"
                        :imgloading="true"
                        :calInternal="true"
                        :showBox="true"
                        :invertBoxShow="true"
                        :sCodes="sCodes"
                        :isDistributed="true"
                        :interfaceName="doorTreeUrl"
                        :params="doorParams"
                        :isPaging="true"
                        @queryUrlResponse="queryDoorUrlResponse"
                    >
                    </td-tree>
                </el-collapse-item>
            </el-collapse>
            <tdwy-collapse
                v-if="normalRole"
                :list="collapseNames"
                :formRoleInfo="formRoleInfo"
                :isAddData="isAddData"
                @sendCheckList="getCheckedList"
                @sendCheckAllChange="checkAllChange"
                @getCheckedAuth="getCheckedAuth"
                @setCheckAllBtnStatus="setCheckAllBtnStatus"
            ></tdwy-collapse>
        </el-form>
        <span slot="footer"
            ><td-button type="primary" @click="submitForm('formRoleInfo')" :loading="loading">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click.native="roleDialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import rolecollapse from './rolecollapse.vue';
import resourceApi from '../assets/api.js';
export default {
    // 初始化渲染
    components: {
        'tdwy-collapse': rolecollapse
    },
    props: ['title', 'dialogRoleVisible', 'editItem', 'isAddData', 'sysFlg', 'sysList', 'orgTreeUrl', 'doorTreeUrl'],
    created() {
        this.getMenuUrl();
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            if (this.editItem.deptType === '1') {
                this.isOrgType = true;
                this.normalRole = false;
            } else if (this.editItem.deptType === '2') {
                this.isDoorType = true;
                this.normalRole = false;
            }
            this.roleTypeList.push({ orgType: '1', orgName: this.$t('common.ORG_ROLE') });
            this.initEditData();
        }

        let roleResData = [];
        let param = {
            sysFlg: this.sysFlg
        };
        resourceApi.listRoleResTypes(JSON.stringify(param), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('role/getAllRoleResType', response.data.statusMessage);
                return;
            }
            //初始化控件起始时间
            if (this.isAddData) {
                let nowDate = new Date(response.headers.date);
                nowDate.setHours(0);
                nowDate.setMinutes(0);
                nowDate.setSeconds(0);
                this.formRoleInfo.startTime = nowDate;
            }

            roleResData = response.data.content;
            // 将权限添加到具体资源
            let res = this.transData2(roleResData, 'resId', 'sParentId', 'authId', 'authTypes');
            // 将json转化为带父子结构
            let result = this.transData1(res, 'resId', 'sParentId', 'authId', 'children');
            if (window.app.sPlatformFlg != 'pg') {
                delete result.pgdata;
            }

            this.collapseNames = result;
            if (!this.isAddData) {
                let checkAuth = [];
                resourceApi.listRoleResAuth(JSON.stringify(this.formRoleInfo), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/auth/role/getCheckedAuth', response.data.statusMessage);
                        return;
                    }
                    checkAuth = response.data.content;
                    this.initCheckState(this.collapseNames, checkAuth);
                });
            }
        });
    },
    mounted() {
        if (!this.isAddData) {
            this.getCheckedDoor();
            if (!this.orgInitFlg) {
                return;
            }
            let paramDept = {
                roleId: this.editItem.roleId,
                menuType: '998'
            };
            this.checkedDept = [];

            resourceApi.getCheckedRoleMenu(JSON.stringify(paramDept), response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getCheckedRoleMenu', response.data.statusMessage);
                    return;
                }
                let dataList = [];
                let menus = response.data.content;
                for (let i in menus) {
                    dataList.push(menus[i].sResId);
                }
                this.checkedDept = dataList;

                let _this = this;
                if (_this.orgInitFlg) {
                    let paramOrg = {
                        url: this.hostUrl,
                        deptUrl: '/OrgManagerController/findOrgIds',
                        parentOrgIds: dataList
                    };
                    //获取所有组织
                    resourceApi.findOrgIds(JSON.stringify(paramOrg), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('/OrgManagerController/findOrgIds', response.data.statusMessage);
                            return;
                        }
                        let res = response.data.content;
                        let allOrgIds = [];
                        if (res) {
                            for (let index = 0; index < res.length; index++) {
                                const element = res[index];
                                allOrgIds.push({ id: element.S_ID, caption: element.S_NAME, parentId: element.SPARENTID });
                            }
                            this.$nextTick(function() {
                                this.$refs.deptTree.setCheckedNodes(allOrgIds);
                            });
                        }
                    });
                }
            });
        }
    },
    // 监听时间
    watch: {
        ['formRoleInfo.startTime'](val) {
            let dateVal = this.formRoleInfo.endTime;
            if (dateVal && val && new Date(val).getTime() > new Date(dateVal).getTime()) {
                this.formRoleInfo.endTime = val;
            }
        },
        ['formRoleInfo.endTime'](val) {
            let dateVal = this.formRoleInfo.startTime;
            if (dateVal && val && new Date(dateVal).getTime() > new Date(val).getTime()) {
                this.formRoleInfo.startTime = val;
            }
        }
    },
    // 定义变量
    data() {
        let validateRoleName = (rule, value, callback) => {
            if (this.isAddData || this.editItem.deptType === '0') {
                let reg = new RegExp(this.$regex.ROLECAPTION_RULE);
                if (!reg.test(value)) {
                    callback(this.$t('error.ERROR_ROLE_CAPTION_ILLEGAL'));
                }
            } else {
                callback();
                return;
            }
            let roleId = '';
            if (!this.isAddData) {
                roleId = this.formRoleInfo.roleId;
            }
            let param = {
                roleName: value,
                sysID: this.sysFlg,
                id: roleId
            };
            resourceApi.getRoleInfoByName(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('role/getRoleInfoByName', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('error.ERROR_ROLE_NAME_REPEAT'));
                } else {
                    callback();
                }
            });
        };
        return {
            // Role表单信息
            hasMenuPermission: true,
            hasOrgPermission: true,
            hasDoorPermission: true,
            pg: true,
            roleTypeList: [{ orgType: '0', orgName: this.$t('common.NORMAL_ROLE') }],
            timeScheduleList: [],
            isOrgType: false,
            isDoorType: false,
            formRoleInfo: {
                startTime: new Date(Date.parse('2000-1-1 00:00:00'.replace(/-/g, '/'))),
                endTime: new Date(Date.parse('2199-12-31 23:59:59'.replace(/-/g, '/'))),
                description: '',
                roleName: '',
                roleType: '0',
                roleId: '',
                resId: '',
                timeScheduleId: '',
                isHolidayInvalid: 0,
                isAntiSneak: 0,
                isPasswordNeeded: 0,
                sysFlg: ''
            },
            filter: [
                {
                    field: 'deviceType',
                    value: 0
                }
            ],
            params: {
                rootCodes: ['BH-0001'],
                currentPage: 1,
                needPage: true,
                pageSize: 50
            },
            doorParams: {
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                deviceTypeList: [50]
            },
            orgInitFlg: true,
            normalRole: true,
            sCodes: ['BH-0001'],
            checkedList: [],
            checkedResAuthList: [],
            checkedDept: [],
            checkedMenu: [],
            resIdList: [],
            menuList: [],
            hostUrl: '',
            defaultProps: {
                children: 'children',
                id: 'menuId',
                label: 'menuName',
                imgName: 'type'
            },
            defaultProps2: {
                children: 'oopp',
                id: 'menuId',
                label: 'text',
                imgName: 'type'
            },
            defaultDeptProps: {
                parentId: 'parentId',
                children: 'children',
                id: 'id',
                label: 'caption',
                imgName: 'sIcon'
            },
            count: 1,
            menuRoles: [],
            collapseNames: [],
            addState: '',
            formLabelWidth: '25%',
            loading: false, // 按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                roleName: [{ required: true, message: this.$t('error.ERROR_ROLE_CAPTION_NULL'), trigger: 'blur' }, { validator: validateRoleName, trigger: 'blur' }],
                roleType: [{ required: true, message: this.$t('roleError.ERROR_ROLE_TYPE_NULL'), trigger: 'blur' }],
                description: [{ min: 1, max: 100, message: this.$t('error.ERROR_URL_MAX_LENGTH'), trigger: 'change' }],
                timeScheduleId: [{ required: true, message: this.$t('roleError.ERROR_ROLE_SCHEDULE_NULL'), trigger: 'blur' }],
                sPassword: [
                    { required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 100, message: this.$t('error.ERROR_PASSWORD_MAX_LENGTH'), trigger: 'blur' }
                ]
            },
            pickerBeginDateBefore: {
                disabledDate: time => {
                    let dateVal = this.formRoleInfo.endTime;
                    if (dateVal) {
                        return time.getTime() > new Date(Date.parse(String(dateVal).replace(/-/g, '/'))).getTime();
                    }
                }
            },
            pickerBeginDateAfter: {
                disabledDate: time => {
                    let dateVal = this.formRoleInfo.startTime;
                    if (dateVal) {
                        return time.getTime() <= new Date(Date.parse(String(dateVal).replace(/-/g, '/'))).getTime() - 8.64e7;
                    }
                }
            }
        };
    },
    // 定义并实现方法体
    methods: {
        //树形查询组织返回结果
        queryUrlResponse(response) {
            if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                this.hasOrgPermission = false;
            } else if (this.$util.isEmpty(response.data.content)) {
                this.hasOrgPermission = false;
            }
        },
        //门禁树形查询返回结果
        queryDoorUrlResponse(response) {
            if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                this.hasDoorPermission = false;
            } else if (this.$util.isEmpty(response.data.content)) {
                this.hasDoorPermission = false;
            }
        },
        //获取当前日期
        getNowDate() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            return year + '-' + month + '-' + day;
        },
        //角色类型选择
        onChangeRoleType(roleType) {
            switch (roleType) {
                case '0':
                    this.isOrgType = false;
                    this.isDoorType = false;
                    this.normalRole = true;
                    break;
                case '1':
                    this.isOrgType = true;
                    this.isDoorType = false;
                    this.normalRole = false;
                    break;
                case '2':
                    this.isOrgType = false;
                    this.isDoorType = true;
                    this.normalRole = false;
                    break;
                default:
                    break;
            }
        },
        initCheckState(list, checkAuth) {
            // 初始化默认选中状态
            for (let j in list) {
                let element = list[j];
                element.checkList = new Array();
                for (let i = 0; i < checkAuth.length; i++) {
                    if (element.resId === checkAuth[i].resId) {
                        let checkObj = {};
                        checkObj = checkAuth[i].resId + ',' + checkAuth[i].authId;
                        element.checkList.push(checkObj);
                        if (element.checkList.length === element.authTypes.length) {
                            element.checkAll = true;
                            //有全选后更改父级节点状态
                            this.setCheckAllBtn(this.collapseNames, element.sParentId, 3, true);
                        }
                    }
                }
                this.initCheckState(element.children, checkAuth);
            }
        },
        getMenuUrl() {
            let arr = this.sysList;
            this.hostUrl = '';
            let menuUrl = '';
            let orgUrl = '';
            for (let index in arr) {
                if (arr[index].sSysFlg === this.sysFlg) {
                    menuUrl = arr[index].sMenuUrl;
                    this.hostUrl = arr[index].sUrl;
                    orgUrl = arr[index].sDeptUrl;
                }
            }
            if (orgUrl === '') {
                this.orgInitFlg = false;
            }
            let param = {
                url: this.hostUrl,
                menuUrl: menuUrl,
                token: sessionStorage.getItem('token'),
                sPlatformFlg: window.app.sPlatformFlg
            };

            if (menuUrl !== '') {
                let _this = this;
                resourceApi.getMenuList(JSON.stringify(param), response => {
                    if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                        this.$log.error(this.hostUrl + menuUrl, response.data.statusMessage);
                        this.hasMenuPermission = false;
                        return;
                    }
                    _this.menuList = response.data.content;
                    let param = {
                        roleId: this.editItem.roleId,
                        rootFlg: 'true',
                        menuType: '3000'
                    };
                    if (!this.isAddData) {
                        resourceApi.getCheckedRoleMenu(JSON.stringify(param), response => {
                            if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('role/getCheckedRoleMenu', response.data.statusMessage);
                                return;
                            }
                            let dataList = [];
                            let menus = response.data.content;
                            for (let i in menus) {
                                dataList.push(menus[i].sResId);
                            }
                            let _this = this;
                            _this.$nextTick(function() {
                                _this.$refs.menuTree.defaultSelect(dataList);
                            });
                        });
                    }
                });
            }
            resourceApi.getAllTimeNoAndUUID('week', response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    // this.$message({ showClose: true, message: this.$t('roleError.ERROR_ROLE_SCHEDULE_ERROR'), type: 'warning' });
                    if (!this.isAddData) {
                        this.roleTypeList.push({ orgType: '2', orgName: this.$t('role.DOOR_ROLE') });
                    }
                    this.formRoleInfo.timeScheduleId = "";
                    this.$log.error('role/getAllTimeNoAndUUID', response.data.statusMessage);
                    return;
                }
                this.roleTypeList.push({ orgType: '2', orgName: this.$t('role.DOOR_ROLE') });
                this.timeScheduleList = response.data.content;
            });
        },
        getCheckedDoor() {
            if (this.editItem.deptType === '2') {
                let param = {
                    roleId: this.editItem.roleId,
                    rootFlg: 'true',
                    menuType: '12014'
                };
                resourceApi.getCheckedRoleMenu(JSON.stringify(param), response => {
                    if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('role/getCheckedRoleMenu', response.data.statusMessage);
                        return;
                    }
                    let dataList = [];
                    let resList = response.data.content;
                    for (let i in resList) {
                        dataList.push(resList[i].sResId);
                    }
                    resourceApi.getDeviceTreeNodeID(JSON.stringify(dataList), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('device/getDeviceTreeNodeID', response.data.statusMessage);
                            return;
                        }
                        let doorCheckedList = response.data.content;
                        let checkedNodesList = [];
                        for (let id of doorCheckedList) {
                            let tmp = {
                                id: id,
                                sId: id.split("_")[1]
                            };
                            checkedNodesList.push(tmp);
                        }
                        let _this = this;
                        _this.$nextTick(function() {
                            _this.$refs.doorTree.setCheckedNodes(checkedNodesList);
                        });
                    });
                });
            }
        },
        getCheckedList(val, data) {
            let resId = data.resId;

            for (let index = 0; index < this.resIdList.length; index++) {
                let element = this.resIdList[index];

                if (element.resId === resId) {
                    element.optionFlg = true;
                }
            }

            let array = this.checkedList;
            for (let index = array.length - 1; index >= 0; index--) {
                if (array[index].indexOf(resId) !== -1) {
                    array.splice(index, 1);
                }
            }
            for (let index = 0; index < val.length; index++) {
                let element = val[index];
                array.push(element);
            }
            this.checkedList = array;
        },
        getCheckedAuth(data) {
            let resId = data.resId;
            let resObj = {
                resId: resId,
                optionFlg: false
            };
            if (this.resIdList.indexOf(resObj) === -1) {
                this.resIdList.push(resObj);
            }
        },
        setCheckAllBtnStatus(val, data) {
            if (val.length === 0) {
                //全不选
                // data.checkAll = false;
                // data.indeterminate = false;
                this.setCheckAllBtn(this.collapseNames, data.resId, 1, val);
            } else if (val.length !== data.authTypes.length) {
                //半选
                // data.checkAll = false;
                // data.indeterminate = true;
                this.setCheckAllBtn(this.collapseNames, data.resId, 2, val);
            } else {
                //全选
                // data.checkAll = true;
                // data.indeterminate = false;
                this.setCheckAllBtn(this.collapseNames, data.resId, 3, val);
            }
            // console.log(this.collapseNames);
        },
        setCheckAllBtn(list, sParentId, state, val) {
            // console.log(list);
            for (let i in list) {
                let obj = list[i];

                if (obj.resId === sParentId) {
                    //当前check组全选，需要判断是否所有都全选，是则将父节点置为全选
                    //当前check组全不选，需要判断是否所有都全不选，是则将父节点置为非选中
                    if (obj.children) {
                        if (obj.children.length > 0) {
                            let result = { all: true, none: true, state: 1 };
                            result = this.getCheckedStatus(obj, result);
                            state = result.state;
                        }
                    }
                    if (obj.authTypes) {
                        if (obj.authTypes.length !== obj.checkList.length) {
                            state = 2;
                        }
                    }
                    if (state === 1) {
                        obj.checkAll = false;
                        // obj.indeterminate = false;
                    } else if (state === 2) {
                        obj.checkAll = false;
                        // obj.indeterminate = true;
                    } else {
                        obj.checkAll = true;
                        // obj.indeterminate = false;
                    }

                    this.setCheckAllBtn(this.collapseNames, obj.sParentId, state, val);
                    break;
                } else {
                    if (obj.children.length > 0) {
                        this.setCheckAllBtn(obj.children, sParentId, state, val);
                    }
                }
            }
        },
        checkAllChange(val, index, data) {
            this.handleCheckAllChange(val, index, data);
            let state = 1;
            if (val === true) {
                state = 3;
            }
            this.setCheckAllBtn(this.collapseNames, data.sParentId, state, val);
        },
        getAllCheckedResAuth(list) {
            for (let i in list) {
                let obj = list[i];
                let element = obj.checkList;
                if (element) {
                    for (let j in element) {
                        this.checkedResAuthList.push(element[j]);
                    }
                }
                if (obj.children) {
                    this.getAllCheckedResAuth(obj.children);
                }
            }
        },
        //全选全不选
        handleCheckAllChange(val, index, data) {
            let _data = data;
            _data.checkAll = val;
            // _data.indeterminate = false;
            if (_data.authTypes) {
                if (!Array.isArray(_data.checkList)) {
                    _data.checkList = new Array();
                }
                if (val) {
                    //增加选中
                    for (let i = 0; i < _data.authTypes.length; i++) {
                        const element = _data.authTypes[i];
                        if (_data.checkList.indexOf(element.authId) === -1) {
                            _data.checkList.push(element.authId);
                        }
                    }
                } else {
                    //取消选中
                    for (let j = _data.checkList.length - 1; j >= 0; j--) {
                        const elementChecked = _data.checkList[j];

                        for (let i = 0; i < _data.authTypes.length; i++) {
                            const element = _data.authTypes[i];

                            if (element.authId == elementChecked) {
                                _data.checkList.splice(j, 1);
                            }
                        }
                    }
                }
            }
            if (_data.children) {
                for (let i = 0; i < _data.children.length; i++) {
                    const elementChild = _data.children[i];
                    this.handleCheckAllChange(val, i, elementChild);
                }
            }
        },
        getCheckedStatus(obj, res) {
            let result = res;
            for (let index = 0; index < obj.children.length; index++) {
                const element = obj.children[index];
                if (element.checkAll !== true) {
                    result.all = false;
                    //如果节点还有子菜单，继续判断
                    if (element.children.length > 0) {
                        result = this.getCheckedStatus(element, result);
                    }
                }
                //当前选中列表不为空，则不是全不选状态
                if (element.checkList && element.checkList.length > 0) {
                    result.none = false;
                }
            }
            if (result.all) {
                result.state = 3;
            } else {
                if (result.none) {
                    result.state = 1;
                } else {
                    result.state = 2;
                }
            }
            return result;
        },
        handleCheckChange(treeNodes, checked, indeterminate) {
            // console.log(treeNodes, checked, indeterminate);
        },
        // 初始化编辑数据
        initEditData() {
            this.formRoleInfo.roleId = this.editItem.roleId;
            this.formRoleInfo.roleName = String(this.editItem.roleName);

            this.formRoleInfo.description = String(this.editItem.roleDescription);
            this.formRoleInfo.startTime = this.editItem.startTime;
            this.formRoleInfo.endTime = this.editItem.endTime;
            this.formRoleInfo.sysFlg = this.sysFlg;
            this.formRoleInfo.roleType = this.editItem.deptType;
            if (this.editItem.deptType !== '0') {
                this.normalRole = false;
            }
            if (this.editItem.deptType === '2') {
                this.formRoleInfo.timeScheduleId = this.editItem.doorScheduleId;
                this.formRoleInfo.isHolidayInvalid = this.editItem.isHolidayInvalid;
                this.formRoleInfo.isAntiSneak = this.editItem.isAntiSneak;
                this.formRoleInfo.isPasswordNeeded = this.editItem.isPasswordNeeded;
            }

        },

        transData(a, idStr, pidStr, chindrenStr) {
            let r = [];
            let hash = {};
            let id = idStr;
            let pid = pidStr;
            let children = chindrenStr;
            let i = 0;
            let j = 0;
            let len = a.length;
            for (; i < len; i++) {
                hash[a[i][id]] = a[i];
            }
            for (; j < len; j++) {
                let aVal = a[j];
                let hashVP = hash[aVal[pid]];
                if (hashVP) {
                    !hashVP[children] && (hashVP[children] = []);
                    hashVP[children].push(aVal);
                } else {
                    r.push(aVal);
                }
            }
            return r;
        },
        transData1(a, idStr, pidStr, authId, chindrenStr) {
            let r = [];
            let hash = {};
            let id = idStr;
            let pid = pidStr;
            let children = chindrenStr;
            let i = 0;
            let j = 0;
            let len = a.length;
            // let authGroupTemp = 0
            for (; i < len; i++) {
                hash[a[i][id]] = a[i];
            }
            for (; j < len; j++) {
                let aVal = a[j];
                // let aaa = ''
                let hashVP = hash[aVal[pid]];

                if (hashVP) {
                    !hashVP[children] && (hashVP[children] = []);
                    hashVP[children].push(aVal);
                } else {
                    r.push(aVal);
                }
            }
            // let res = []
            let hashRes = {};
            for (let k = 0; k < r.length; k++) {
                hashRes[r[k][id]] = r[k];
            }
            return hashRes;
        },
        transData2(a, resId, pidStr, authIds, chindrenStr) {
            let r = [];
            let rid = resId;
            let aId = authIds;
            let children = chindrenStr;

            let len = a.length;
            for (let i = 0; i < len; i++) {
                let aValOut = a[i];
                for (let j = 0; j < len; j++) {
                    // let aVal = a[j]
                    let aVal = {};
                    aVal.authName = a[j]['authName'];
                    aVal.authId = a[j]['resId'] + ',' + a[j][aId];
                    aVal.iDelFlg = 0;
                    aVal.resName = '';
                    aVal.resId = a[j]['resId'] + a[j][aId];
                    aVal.sParentId = '';
                    if (a[j][aId] !== 0 && a[j][aId] !== '' && a[j][rid] === a[i][rid]) {
                        !aValOut[children] && (aValOut[children] = []);
                        aValOut[children].push(aVal);
                    }
                }
                r.push(aValOut);
            }
            let hashRes = {};
            for (let k = 0; k < r.length; k++) {
                hashRes[r[k][rid]] = r[k];
            }
            let arr = [];
            for (let i in hashRes) {
                arr.push(hashRes[i]); // 属性
            }
            return arr;
        },
        // 提交数据
        submitForm(formName) {
            // console.log(this.$refs.menuTree.getCheckedKeys())
            let _this = this;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let resAuthlistArr = [];
                    this.checkedResAuthList = [];
                    if (this.normalRole) {
                        this.getAllCheckedResAuth(this.collapseNames);
                        resAuthlistArr = this.checkedResAuthList;
                    }

                    const menuType = '3000';
                    const deptType = '998';
                    const doorType = '12014';

                    // ES6牛逼方法，不兼容IE。。。暂时放弃
                    // let newarr = Array.from(new Set(this.checkedList))
                    let menuIdList = '';
                    if (this.normalRole || this.isOrgType) {
                        let menuIdArr = _this.$refs.menuTree.getCheckedKeys();
                        if (menuIdArr.length > 0) {
                            menuIdList = menuIdArr.join('|');
                        }
                        let menuRootNodes = this.$refs.menuTree.getHalfCheckedNodes();
                        // let menuRootIds = []
                        for (let index = 0; index < menuRootNodes.length; index++) {
                            let element = menuRootNodes[index];
                            menuIdList += '|' + element.menuId;
                        }
                    }
                    let doorIdList = [];
                    if (this.isDoorType) {
                        let doorIdNodes = _this.$refs.doorTree.getCheckedNodes();
                        for (let index = 0; index < doorIdNodes.length; index++) {
                            let element = doorIdNodes[index];
                            doorIdList.push(element.sId);
                        }
                    }
                    
                    let orgIds = [];
                    if (_this.orgInitFlg && (this.normalRole || this.isOrgType)) {
                        let deptIdNodes = _this.$refs.deptTree.getCheckedNodes();
                        for (let index = 0; index < deptIdNodes.length; index++) {
                            let element = deptIdNodes[index];
                            orgIds.push(element.id);
                        }
                    }

                    let resIdArr = [];
                    let resArr = this.resIdList;
                    for (let index = 0; index < resArr.length; index++) {
                        let element = resArr[index];
                        if (element.optionFlg === true) {
                            resIdArr.push(element.resId);
                        }
                    }
                    if (_this.orgInitFlg && (this.normalRole || this.isOrgType)) {
                        let paramOrg = {
                            url: this.hostUrl,
                            deptUrl: '/OrgManagerController/findOrgIds',
                            parentOrgIds: orgIds
                        };
                        //获取所有组织
                        resourceApi.findOrgIds(JSON.stringify(paramOrg), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/OrgManagerController/findOrgIds', response.data.statusMessage);
                                this.loading = false;
                                return;
                            }
                            let res = response.data.content;
                            let allOrgIds = [];
                            if (res) {
                                for (let index = 0; index < res.length; index++) {
                                    const element = res[index];
                                    allOrgIds.push(element.S_ID);
                                }
                            }
                            let content = {
                                startTime: this.formRoleInfo.startTime,
                                endTime: this.formRoleInfo.endTime,
                                sysFlg: this.sysFlg,
                                roleName: this.formRoleInfo.roleName,
                                roleDescription: this.formRoleInfo.description,
                                roleId: this.formRoleInfo.roleId,
                                resId: this.formRoleInfo.resId,
                                resIdList: resIdArr.join(','),
                                resAuthList: resAuthlistArr.join('|'),
                                menuIds: menuIdList,
                                menuType: menuType,
                                deptIds: allOrgIds.join('|'),
                                deptType: deptType,
                                hasMenuPermission: this.hasMenuPermission,
                                hasOrgPermission: this.hasOrgPermission
                            };
                            if (this.isAddData) {
                                resourceApi.insertRoleInfo(JSON.stringify(content), response => {
                                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                        this.$log.error('role/insertRoleInfo', response.data.statusMessage);
                                        this.loading = false;
                                        return;
                                    }
                                    this.loading = false;
                                    this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                                    this.roleDialogClose();
                                    this.$emit('submit');
                                });
                            } else {
                                content.resId = this.editItem.resId;
                                resourceApi.updateRoleInfo(JSON.stringify(content), response => {
                                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                        this.$log.error('role/updateRoleInfo', response.data.statusMessage);
                                        this.loading = false;
                                        return;
                                    }
                                    this.loading = false;
                                    this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                                    this.roleDialogClose();
                                    this.$emit('submit');
                                });
                            }
                        });
                    } else {
                        let content = {
                            startTime: this.formRoleInfo.startTime,
                            endTime: this.formRoleInfo.endTime,
                            sysFlg: this.sysFlg,
                            roleName: this.formRoleInfo.roleName,
                            roleDescription: this.formRoleInfo.description,
                            roleId: this.formRoleInfo.roleId,
                            resId: this.formRoleInfo.resId,
                            resIdList: resIdArr.join(','),
                            resAuthList: resAuthlistArr.join('|'),
                            menuIds: menuIdList,
                            menuType: menuType,
                            doorIds: doorIdList.join('|'),
                            doorType: doorType,
                            doorScheduleId: this.formRoleInfo.timeScheduleId,
                            isHolidayInvalid: this.formRoleInfo.isHolidayInvalid,
                            isAntiSneak: this.formRoleInfo.isAntiSneak,
                            isPasswordNeeded: this.formRoleInfo.isPasswordNeeded,
                            roleType: this.formRoleInfo.roleType,
                            deptType: deptType,
                            hasMenuPermission: this.hasMenuPermission,
                            hasOrgPermission: this.hasOrgPermission
                        };

                        if (this.isAddData) {
                            resourceApi.insertRoleInfo(JSON.stringify(content), response => {
                                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                    this.$log.error('role/insertRoleInfo', response.data.statusMessage);
                                    this.loading = false;
                                    return;
                                }
                                this.loading = false;
                                this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                                this.roleDialogClose();
                                this.$emit('submit');
                            });
                        } else {
                            content.resId = this.editItem.resId;
                            resourceApi.updateRoleInfo(JSON.stringify(content), response => {
                                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                    this.$log.error('role/updateRoleInfo', response.data.statusMessage);
                                    this.loading = false;
                                    return;
                                }
                                this.loading = false;
                                this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                                this.roleDialogClose();
                                this.$emit('submit');
                            });
                        }
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        roleDialogClose() {
            this.$emit('roleDialogClose');
            this.$refs['formRoleInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
